import React, { useState } from 'react';
import AccountantSidebar from './components/AccountantSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Search,
    Filter,
    MoreHorizontal,
    Plus,
    DollarSign,
    User,
    Calendar,
    ChevronRight,
    Search as SearchIcon,
    ArrowUpRight,
    Printer,
    Download
} from 'lucide-react';

export default function FeeCollection() {
    const [searchTerm, setSearchTerm] = useState('');

    const studentFees = [
        { id: 'STU001', name: 'Rohit Sharma', class: 'Grade 10-A', total: '₹45,000', paid: '₹33,000', balance: '₹12,000', status: 'Partially Paid' },
        { id: 'STU002', name: 'Sanya Mirza', class: 'Grade 8-B', total: '₹35,000', paid: '₹35,000', balance: '₹0', status: 'Fully Paid' },
        { id: 'STU003', name: 'Virat Kohli', class: 'Grade 11-A', total: '₹55,000', paid: '₹0', balance: '₹55,000', status: 'Unpaid' },
        { id: 'STU004', name: 'PV Sindhu', class: 'Grade 9-C', total: '₹40,000', paid: '₹40,000', balance: '₹0', status: 'Fully Paid' },
        { id: 'STU005', name: 'Hardik Pandya', class: 'Grade 12-B', total: '₹60,000', paid: '₹40,000', balance: '₹20,000', status: 'Partially Paid' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AccountantSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Fee Collection"
                    subtitle="Track payments, generate receipts and manage student balances"
                >
                    <button className="flex items-center gap-3 py-2.5 px-6 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Record Payment
                    </button>
                </Header>

                <div className="max-w-7xl mx-auto">
                    {/* Search and Filters */}
                    <div className="bg-white p-8 rounded-[32px] border border-gray-100 shadow-sm mb-8 flex flex-col md:flex-row items-center justify-between gap-6">
                        <div className="relative flex-1 w-full group">
                            <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-500 transition-colors" size={18} />
                            <input
                                type="text"
                                placeholder="UID, Name or Class..."
                                className="w-full h-11 pl-11 pr-4 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="flex items-center gap-3 w-full md:w-auto">
                            <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50 uppercase tracking-tight">
                                <Filter size={18} className="text-gray-400" />
                                Filters
                            </button>
                            <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50 uppercase tracking-tight">
                                <Download size={18} className="text-gray-400" />
                                Export
                            </button>
                        </div>
                    </div>

                    {/* Fee Status Table */}
                    <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10">
                        <div className="p-8 flex items-center justify-between border-b border-gray-50">
                            <div className="flex items-center gap-6">
                                <h3 className="text-[20px] font-black text-[#111827]">Financial Registry</h3>
                                <div className="flex items-center gap-2">
                                    <span className="w-2.5 h-2.5 bg-blue-500 rounded-full animate-pulse"></span>
                                    <span className="text-gray-400 font-bold text-[14px]">March 2026 Collections</span>
                                </div>
                            </div>
                            <button className="p-1.5 text-gray-400 hover:text-gray-900"><MoreHorizontal size={22} /></button>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="w-full text-left">
                                <thead className="bg-[#F8FAFC]">
                                    <tr>
                                        <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Student</th>
                                        <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Summary</th>
                                        <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Balance</th>
                                        <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Status</th>
                                        <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-right">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {studentFees.map((stu, i) => (
                                        <tr key={i} className="border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group">
                                            <td className="px-8 py-5">
                                                <div className="flex items-center gap-4">
                                                    <div className="w-11 h-11 rounded-xl bg-blue-50 text-blue-500 flex items-center justify-center font-black group-hover:scale-105 transition-transform overflow-hidden italic text-xs uppercase">
                                                        {stu.name.split(' ').map(n => n[0]).join('')}
                                                    </div>
                                                    <div>
                                                        <p className="text-[15px] font-black text-[#111827] mb-0.5">{stu.name}</p>
                                                        <p className="text-[12px] font-bold text-gray-400 uppercase tracking-tighter">UID: {stu.id} | {stu.class}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-5">
                                                <div className="space-y-1">
                                                    <div className="flex items-center justify-between gap-4">
                                                        <span className="text-[11px] font-bold text-gray-400 uppercase">Total</span>
                                                        <span className="text-[13px] font-black text-[#111827]">{stu.total}</span>
                                                    </div>
                                                    <div className="flex items-center justify-between gap-4">
                                                        <span className="text-[11px] font-bold text-gray-400 uppercase">Paid</span>
                                                        <span className="text-[13px] font-black text-emerald-500">{stu.paid}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-5 text-center">
                                                <p className={`text-[17px] font-black tracking-tighter ${stu.balance === '₹0' ? 'text-gray-300' : 'text-rose-500'}`}>
                                                    {stu.balance}
                                                </p>
                                            </td>

                                            <td className="px-6 py-5 text-center">
                                                <span className={`px-4 py-1.5 rounded-lg text-[11px] font-black uppercase tracking-widest ${stu.status === 'Fully Paid' ? 'text-emerald-500 bg-emerald-50' :
                                                    stu.status === 'Partially Paid' ? 'text-amber-500 bg-amber-50' :
                                                        'text-rose-500 bg-rose-50'
                                                    }`}>
                                                    {stu.status}
                                                </span>
                                            </td>
                                            <td className="px-8 py-5 text-right">
                                                <div className="flex items-center justify-end gap-1">
                                                    <button className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-xl transition-all" title="Print Receipt">
                                                        <Printer size={16} />
                                                    </button>
                                                    <button className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-xl transition-all" title="Record Payment">
                                                        <Plus size={16} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
